"use client"

import { useState, useEffect } from "react"
import { useAuth } from "../../../contexts/AuthContext"
import { API_BASE_URL } from "../../../config/api"
import Swal from "sweetalert2"
import {
  UserIcon,
  EnvelopeIcon,
  MapPinIcon,
  BriefcaseIcon,
  GlobeAltIcon,
  KeyIcon,
  ShieldCheckIcon,
  CurrencyDollarIcon,
  CheckCircleIcon,
  XCircleIcon,
  EyeIcon,
  EyeSlashIcon,
  PencilIcon,
  CheckIcon,
  XMarkIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ClipboardDocumentIcon,
} from "@heroicons/react/24/outline"

import { useParams } from "react-router-dom"

const socialIcons = {
  facebook: (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
    </svg>
  ),
  twitter: (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
    </svg>
  ),
  linkedin: (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  ),
  instagram: (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12.017 0C8.396 0 7.929.01 6.684.048 5.443.085 4.60.204 3.875.43c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.403 4.864.284 5.706.247 6.95.01 8.195 0 8.663 0 12.017s.01 3.807.048 5.052c.036 1.243.155 2.085.38 2.81.306.788.717 1.458 1.384 2.125.667.666 1.336 1.079 2.126 1.384.724.226 1.566.344 2.809.381 1.244.038 1.713.047 5.051.047 3.338 0 3.807-.01 5.052-.047 1.243-.037 2.085-.155 2.81-.381.788-.306 1.458-.718 2.125-1.384.666-.667 1.079-1.337 1.384-2.126.226-.724.344-1.566.381-2.809.038-1.244.047-1.713.047-5.052 0-3.338-.01-3.807-.047-5.051-.037-1.244-.155-2.086-.381-2.81-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.725-.226-1.567-.344-2.81-.381C15.806.01 15.337 0 12.017 0zm0 2.16c3.304 0 3.694.012 4.99.048 1.204.055 1.858.249 2.292.413.576.224.988.491 1.421.924.433.433.7.845.924 1.421.164.434.358 1.088.413 2.292.036 1.297.047 1.686.047 4.99s-.011 3.694-.048 4.99c-.055 1.204-.249 1.858-.413 2.292-.224.576-.491.988-.924 1.421-.433.433-.845.7-1.421.924-.434.164-1.088.358-2.292.413-1.297.036-1.686.047-4.99.047s-3.694-.011-4.99-.048c-1.204-.055-1.858-.249-2.292-.413-.576-.224-.988-.491-1.421.924-.433-.433-.7-.845-.924-1.421-.164-.434-.358-1.088-.413-2.292-.036-1.297-.047-1.686-.047-4.99s.011-3.694.048-4.99c.055-1.204.249-1.858.413-2.292.224-.576.491-.988.924-1.421.433-.433.845-.7 1.421-.924.434-.164 1.088-.358 2.292-.413 1.297-.036 1.686.047 4.99-.047z" />
    </svg>
  ),
  youtube: (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  ),
  github: (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
    </svg>
  ),
}

const UserProfile = () => {
  const { userId } = useParams()
  const {
    user,
    getUserProfile,
    updateUserProfile,
    sendVerificationEmail,
    verifyEmail,
    addIPToWhitelist,
    removeIPFromWhitelist,
    toggleIPWhitelistStatus,
    toggleUserIPWhitelist,
    updateUserSecuritySettings,
    startTwoFactorSetup,
    confirmTwoFactorSetup,
    addIPToBlocklist,
    removeIPFromBlocklist,
    toggleIPBlocklistStatus,
    toggleUserIPBlocklist,
    regenerateApiKey,
    getUserApiKey,
    canEditProfile,
    canEditWhatsAppCredentials,
    canViewProfile,
    updateResellerBranding,
    uploadResellerLogo,
  } = useAuth()
  const getUserId = () => {
    const path = window.location.pathname
    const segments = path.split("/")
    const userProfileIndex = segments.indexOf("userprofile")
    if (userProfileIndex !== -1 && segments[userProfileIndex + 1]) {
      return segments[userProfileIndex + 1]
    }
    return null
  }

  //const [userId] = useState(() => getUserId())

  const [profileUser, setProfileUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [currentStep, setCurrentStep] = useState(1)
  const [isEditing, setIsEditing] = useState(false)
  const [showApiKey, setShowApiKey] = useState(false)
  const [apiKey, setApiKey] = useState("")
  const [newIP, setNewIP] = useState("")
  const [newBlockedIP, setNewBlockedIP] = useState("")
  const [twoFactorSetup, setTwoFactorSetup] = useState(null)
  const [twoFactorSetupCode, setTwoFactorSetupCode] = useState("")
  const [verificationCode, setVerificationCode] = useState("")
  const [showVerificationModal, setShowVerificationModal] = useState(false)
  const [error, setError] = useState(null)

  const [formData, setFormData] = useState({
    // Personal Information
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    number: "",
    dateOfBirth: "",
    gender: "",
    address: "",
    city: "",
    state: "",
    country: "",
    zipCode: "",
    alternateEmail: "",
    alternatePhone: "",

    // Professional Information
    jobTitle: "",
    company: "",
    department: "",
    bio: "",
    website: "",

    // Social Media
    socialMedia: {
      facebook: "",
      twitter: "",
      linkedin: "",
      instagram: "",
      youtube: "",
      github: "",
    },

    // WhatsApp Credentials
    wptoken: "",
    cloudNumber: "",
    phoneNumberId: "",
    wabaId: "",
    businessId: "",
    businessAccountId: "",
    appId: "",
    webhookUrl: "",
    template: "",
    wpCloudApi: "",

    // Account Settings
    emailNotifications: true,
    smsNotifications: true,
    userStatus: "active",
    role: "user",
    operator: "cloud",

    // Settings
    settings: {
      optOutKeywords: ["stop", "unsubscribe", "opt out", "opt-out", "cancel", "quit"],
      optInKeywords: ["start", "subscribe"],
    },
  })

  const fetchUserProfile = async () => {
    try {
      setLoading(true)
      setError(null)

      let profileData
      if (userId) {
        // Fetch profile by userId from URL
        profileData = await getUserProfile(userId)
      } else {
        // No param → fetch logged-in user's own profile
        profileData = { success: true, user }
      }

      if (profileData && profileData.success) {
        setProfileUser(profileData.user)
        setFormData(profileData.user)
      } else {
        setError("User profile not found")
      }
    } catch (error) {
      console.error("Error fetching user profile:", error)
      setError(error.message || "Failed to load user profile")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const tab = new URLSearchParams(window.location.search).get("tab")
    if (tab === "security") {
      setCurrentStep(3)
    } else if (tab === "settings") {
      setCurrentStep(4)
    }
  }, [])

  useEffect(() => {
    const fetchProfile = async () => {
      const result = await getUserProfile(userId) // can be undefined
      if (result.success) {
        setProfileUser(result.user)
        setFormData(result.user)
      } else {
        setError(result.error)
      }
      setLoading(false)
    }
    fetchProfile()
  }, [userId, getUserProfile])

  const fetchApiKey = async () => {
    try {
      const result = await getUserApiKey()
      if (result.success) {
        setApiKey(result.apiKey)
      }
    } catch (error) {
      console.error("Error fetching API key:", error)
    }
  }

  const handleSaveProfile = async () => {
    const checkWabaNumbers = formData.wabaNumbers || []
    
    const checkPrimaryLabel = (formData.label || formData.username || "").trim().toLowerCase()
    const checkPrimaryPhoneId = (formData.phoneNumberId || "").trim().toLowerCase()
    const checkPrimaryCloudNum = (formData.cloudNumber || formData.number || "").trim().toLowerCase()
    const checkPrimaryWabaId = (formData.wabaId || formData.businessAccountId || formData.businessId || "").trim().toLowerCase()
    const checkPrimaryToken = (formData.wptoken || formData.token || formData.apiKey || "").trim().toLowerCase()

    const seenLabels = new Set(checkPrimaryLabel ? [checkPrimaryLabel] : [])
    const seenPhoneIds = new Set(checkPrimaryPhoneId ? [checkPrimaryPhoneId] : [])
    const seenCloudNums = new Set(checkPrimaryCloudNum ? [checkPrimaryCloudNum] : [])
    const seenWabaIds = new Set(checkPrimaryWabaId ? [checkPrimaryWabaId] : [])
    const seenTokens = new Set(checkPrimaryToken ? [checkPrimaryToken] : [])

    if (Array.isArray(checkWabaNumbers)) {
      for (const wn of checkWabaNumbers) {
        const lbl = (wn.label || "").trim().toLowerCase()
        const phoneId = (wn.phoneNumberId || "").trim().toLowerCase()
        const cloudNum = (wn.cloudNumber || "").trim().toLowerCase()
        const waba = (wn.wabaId || "").trim().toLowerCase()
        const tok = (wn.token || "").trim().toLowerCase()

        if (lbl) {
          if (seenLabels.has(lbl)) {
            Swal.fire({
              icon: "error",
              title: "Duplicate Label Found",
              text: `The label "${wn.label}" is already used. Each sender number must have a unique label.`,
              confirmButtonColor: "#4A7C59",
            })
            return
          }
          seenLabels.add(lbl)
        }
        if (phoneId) {
          if (seenPhoneIds.has(phoneId)) {
            Swal.fire({
              icon: "error",
              title: "Duplicate Phone Number ID Found",
              text: `The Phone Number ID "${wn.phoneNumberId}" is already used. Each sender number must have a unique Phone Number ID.`,
              confirmButtonColor: "#4A7C59",
            })
            return
          }
          seenPhoneIds.add(phoneId)
        }
        if (cloudNum) {
          if (seenCloudNums.has(cloudNum)) {
            Swal.fire({
              icon: "error",
              title: "Duplicate Cloud Number Found",
              text: `The Cloud Number "${wn.cloudNumber}" is already used. Each sender number must have a unique Cloud Number.`,
              confirmButtonColor: "#4A7C59",
            })
            return
          }
          seenCloudNums.add(cloudNum)
        }
        if (waba) {
          if (seenWabaIds.has(waba)) {
            Swal.fire({
              icon: "error",
              title: "Duplicate WabaId Found",
              text: `The WabaId "${wn.wabaId}" is already used. Each sender number must have a unique WabaId.`,
              confirmButtonColor: "#4A7C59",
            })
            return
          }
          seenWabaIds.add(waba)
        }
        if (tok) {
          if (seenTokens.has(tok)) {
            Swal.fire({
              icon: "error",
              title: "Duplicate Token Found",
              text: `The Token "${wn.token}" is already used. Each sender number must have a unique Token.`,
              confirmButtonColor: "#4A7C59",
            })
            return
          }
          seenTokens.add(tok)
        }
      }
    }

    try {
      setLoading(true)

      const result = await updateUserProfile(userId, formData)

      if (result.success) {
        Swal.fire({
          icon: "success!",
          title: "Success",
          text: "Profile updated successfully",
          confirmButtonColor: "#4A7C59",
        })
        setIsEditing(false)
        fetchUserProfile()
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.error || "Failed to update profile",
          confirmButtonColor: "#4A7C59",
        })
      }
    } catch (error) {
      console.error("Error updating profile:", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update profile",
        confirmButtonColor: "#4A7C59",
      })
    } finally {
      setLoading(false)
    }
  }

  const handleSendVerificationEmail = async () => {
    try {
      setLoading(true)
      const result = await sendVerificationEmail(profileUser.email)

      if (result.success) {
        setShowVerificationModal(true)
        Swal.fire({
          icon: "success",
          title: "Verification Code Sent",
          text: `Verification code sent to ${profileUser.email}`,
          confirmButtonColor: "#4A7C59",
        })
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.error || "Failed to send verification code",
          confirmButtonColor: "#4A7C59",
        })
      }
    } catch (error) {
      console.error("Error sending verification email:", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to send verification code",
        confirmButtonColor: "#4A7C59",
      })
    } finally {
      setLoading(false)
    }
  }

  const handleVerifyEmail = async () => {
    if (!verificationCode) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please enter the verification code",
        confirmButtonColor: "#4A7C59",
      })
      return
    }

    try {
      setLoading(true)
      const result = await verifyEmail(profileUser.email, verificationCode)

      if (result.success) {
        Swal.fire({
          icon: "success",
          title: "Email Verified!",
          text: "Email has been verified successfully",
          confirmButtonColor: "#4A7C59",
        })
        setShowVerificationModal(false)
        setVerificationCode("")
        fetchUserProfile()
      } else {
        Swal.fire({
          icon: "error",
          title: "Verification Failed",
          text: result.error || "Invalid verification code",
          confirmButtonColor: "#4A7C59",
        })
      }
    } catch (error) {
      console.error("Error verifying email:", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to verify email",
        confirmButtonColor: "#4A7C59",
      })
    } finally {
      setLoading(false)
    }
  }

  const handleAddIP = async () => {
    if (!newIP) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please enter an IP address",
        confirmButtonColor: "#4A7C59",
      })
      return
    }

    try {
      setLoading(true)
      const result = await addIPToWhitelist(userId, newIP)

      if (result.success) {
        Swal.fire({
          icon: "success!",
          title: "Success!",
          text: result.message || "IP address added to whitelist",
          confirmButtonColor: "#4A7C59",
        })
        setNewIP("")
        fetchUserProfile()
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.error || "Failed to add IP address",
          confirmButtonColor: "#4A7C59",
        })
      }
    } catch (error) {
      console.error("Error adding IP:", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to add IP address",
        confirmButtonColor: "#4A7C59",
      })
    } finally {
      setLoading(false)
    }
  }

  const handleToggleTwoFactor = async () => {
    if (!profileUser.twoFactorEnabled) {
      try {
        setLoading(true)
        const result = await startTwoFactorSetup(userId)

        if (result.success) {
          setTwoFactorSetup(result)
          setTwoFactorSetupCode("")
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: result.error || "Failed to start two-factor setup",
            confirmButtonColor: "#4A7C59",
          })
        }
      } catch (error) {
        console.error("Error starting two-factor setup:", error)
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to start two-factor setup",
          confirmButtonColor: "#4A7C59",
        })
      } finally {
        setLoading(false)
      }
      return
    }

    const confirm = await Swal.fire({
      title: "Disable Two-Factor Authentication?",
      text: "Your account will no longer ask for an authenticator code at login.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#EF4444",
      cancelButtonColor: "#6B7280",
      confirmButtonText: "Disable",
    })

    if (!confirm.isConfirmed) return

    try {
      setLoading(true)
      const result = await updateUserSecuritySettings(userId, { twoFactorEnabled: false })

      if (result.success) {
        setProfileUser((prev) => ({ ...prev, twoFactorEnabled: false }))
        setTwoFactorSetup(null)
        setTwoFactorSetupCode("")
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Two-factor authentication disabled",
          confirmButtonColor: "#4A7C59",
        })
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.error || "Failed to update two-factor authentication",
          confirmButtonColor: "#4A7C59",
        })
      }
    } catch (error) {
      console.error("Error updating two-factor authentication:", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update two-factor authentication",
        confirmButtonColor: "#4A7C59",
      })
    } finally {
      setLoading(false)
    }
  }

  const handleConfirmTwoFactorSetup = async () => {
    if (!twoFactorSetupCode) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please enter the 6-digit code from your authenticator app",
        confirmButtonColor: "#4A7C59",
      })
      return
    }

    try {
      setLoading(true)
      const result = await confirmTwoFactorSetup(userId, twoFactorSetupCode)

      if (result.success) {
        setProfileUser((prev) => ({ ...prev, twoFactorEnabled: true }))
        setTwoFactorSetup(null)
        setTwoFactorSetupCode("")
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Two-factor authentication enabled",
          confirmButtonColor: "#4A7C59",
        })
      } else {
        Swal.fire({
          icon: "error",
          title: "Invalid Code",
          text: result.error || "Failed to verify authenticator code",
          confirmButtonColor: "#4A7C59",
        })
      }
    } catch (error) {
      console.error("Error confirming two-factor setup:", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to verify authenticator code",
        confirmButtonColor: "#4A7C59",
      })
    } finally {
      setLoading(false)
    }
  }

  const handleToggleUserIPWhitelist = async () => {
    try {
      setLoading(true)
      const enabled = !profileUser.ipWhitelistEnabled
      const result = await toggleUserIPWhitelist(userId, enabled)

      if (result.success) {
        setProfileUser((prev) => ({ ...prev, ipWhitelistEnabled: enabled }))
        fetchUserProfile()
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.error || "Failed to update IP whitelist",
          confirmButtonColor: "#4A7C59",
        })
      }
    } catch (error) {
      console.error("Error updating IP whitelist:", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update IP whitelist",
        confirmButtonColor: "#4A7C59",
      })
    } finally {
      setLoading(false)
    }
  }

  const handleToggleIPWhitelistStatus = async (ip, isActive) => {
    try {
      setLoading(true)
      const result = await toggleIPWhitelistStatus(userId, ip, isActive)
      if (result.success) {
        fetchUserProfile()
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.error || "Failed to update IP status",
          confirmButtonColor: "#4A7C59",
        })
      }
    } finally {
      setLoading(false)
    }
  }

  const handleRemoveIP = async (ip) => {
    const result = await Swal.fire({
      title: "Remove IP Address?",
      text: `Are you sure you want to remove ${ip} from the whitelist?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#EF4444",
      cancelButtonColor: "#6B7280",
      confirmButtonText: "Yes, remove it",
    })

    if (!result.isConfirmed) return

    try {
      setLoading(true)
      const removeResult = await removeIPFromWhitelist(userId, ip)

      if (removeResult.success) {
        Swal.fire({
          icon: "success!",
          title: "Success!",
          text: "IP address removed from whitelist",
          confirmButtonColor: "#4A7C59",
        })
        fetchUserProfile()
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: removeResult.error || "Failed to remove IP address",
          confirmButtonColor: "#4A7C59",
        })
      }
    } catch (error) {
      console.error("Error removing IP:", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to remove IP address",
        confirmButtonColor: "#4A7C59",
      })
    } finally {
      setLoading(false)
    }
  }

  const handleAddBlockedIP = async () => {
    if (!newBlockedIP) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please enter an IP address",
        confirmButtonColor: "#4A7C59",
      })
      return
    }

    try {
      setLoading(true)
      const result = await addIPToBlocklist(userId, newBlockedIP)

      if (result.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: result.message || "IP address added to blocklist",
          confirmButtonColor: "#4A7C59",
        })
        setNewBlockedIP("")
        fetchUserProfile()
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.error || "Failed to add IP address",
          confirmButtonColor: "#4A7C59",
        })
      }
    } catch (error) {
      console.error("Error adding blocked IP:", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to add IP address",
        confirmButtonColor: "#4A7C59",
      })
    } finally {
      setLoading(false)
    }
  }

  const handleRemoveBlockedIP = async (ip) => {
    const result = await Swal.fire({
      title: "Remove Blocked IP?",
      text: `Are you sure you want to remove ${ip} from the blocklist?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#EF4444",
      cancelButtonColor: "#6B7280",
      confirmButtonText: "Yes, remove it",
    })

    if (!result.isConfirmed) return

    try {
      setLoading(true)
      const removeResult = await removeIPFromBlocklist(userId, ip)

      if (removeResult.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "IP address removed from blocklist",
          confirmButtonColor: "#4A7C59",
        })
        fetchUserProfile()
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: removeResult.error || "Failed to remove IP address",
          confirmButtonColor: "#4A7C59",
        })
      }
    } catch (error) {
      console.error("Error removing blocked IP:", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to remove IP address",
        confirmButtonColor: "#4A7C59",
      })
    } finally {
      setLoading(false)
    }
  }

  const handleToggleIPBlocklistStatus = async (ip, isActive) => {
    try {
      setLoading(true)
      const result = await toggleIPBlocklistStatus(userId, ip, isActive)
      if (result.success) {
        fetchUserProfile()
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.error || "Failed to update IP status",
          confirmButtonColor: "#4A7C59",
        })
      }
    } finally {
      setLoading(false)
    }
  }

  const handleToggleUserIPBlocklist = async () => {
    try {
      setLoading(true)
      const enabled = !profileUser.ipBlocklistEnabled
      const result = await toggleUserIPBlocklist(userId, enabled)

      if (result.success) {
        setProfileUser((prev) => ({ ...prev, ipBlocklistEnabled: enabled }))
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.error || "Failed to update IP blocklist",
          confirmButtonColor: "#4A7C59",
        })
      }
    } catch (error) {
      console.error("Error updating IP blocklist:", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update IP blocklist",
        confirmButtonColor: "#4A7C59",
      })
    } finally {
      setLoading(false)
    }
  }

  const handleRegenerateApiKey = async () => {
    const result = await Swal.fire({
      title: "Regenerate API Key?",
      text: "This will invalidate the current API key. Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#EF4444",
      cancelButtonColor: "#6B7280",
      confirmButtonText: "Yes, regenerate",
    })

    if (!result.isConfirmed) return

    try {
      setLoading(true)
      const regenerateResult = await regenerateApiKey()

      if (regenerateResult.success) {
        setApiKey(regenerateResult.apiKey)
        Swal.fire({
          icon: "success!",
          title: "Success!",
          text: "API key regenerated successfully",
          confirmButtonColor: "#4A7C59",
        })
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: regenerateResult.error || "Failed to regenerate API key",
          confirmButtonColor: "#4A7C59",
        })
      }
    } catch (error) {
      console.error("Error regenerating API key:", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to regenerate API key",
        confirmButtonColor: "#4A7C59",
      })
    } finally {
      setLoading(false)
    }
  }

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
    Swal.fire({
      icon: "success",
      title: "Copied!",
      text: "Copied to clipboard",
      timer: 1500,
      showConfirmButton: false,
    })
  }

  const nextStep = () => {
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1)
    }
  }

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1)
    }
  }

  const renderStepContent = () => {
    if (!profileUser) return null

    switch (currentStep) {
      case 1:
        return (
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">User Details & Social</h3>

            {/* Basic Info */}
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                <UserIcon className="w-5 h-5" />
                Basic Information
              </h4>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">First Name</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={formData.firstName}
                      onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.firstName || "Not provided"}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Last Name</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={formData.lastName}
                      onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.lastName || "Not provided"}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Username</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={formData.username}
                      onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.username || "Not provided"}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Phone Number
                  </label>
                  {isEditing ? (
                    <input
                      type="tel"
                      value={formData.number}
                      onChange={(e) => setFormData({ ...formData, number: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.number || "Not provided"}</p>
                  )}
                </div>
              </div>
            </div>

            {/* Email & Verification */}
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                <EnvelopeIcon className="w-5 h-5" />
                Email & Verification
              </h4>

              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-700 dark:text-gray-300">Email Address</p>
                    <p className="text-gray-900 dark:text-white">{profileUser.email}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    {profileUser.isEmailVerified ? (
                      <span className="flex items-center gap-1 text-green-600 dark:text-green-400">
                        <CheckCircleIcon className="w-5 h-5" />
                        Verified
                      </span>
                    ) : (
                      <div className="flex items-center gap-2">
                        <span className="flex items-center gap-1 text-red-600 dark:text-red-400">
                          <XCircleIcon className="w-5 h-5" />
                          Not Verified
                        </span>
                        {canEditProfile(userId) && (
                          <button
                            onClick={handleSendVerificationEmail}
                            className="px-3 py-1 bg-green-600 hover:bg-green-700 text-white text-sm rounded-lg transition-colors"
                          >
                            Verify Now
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Balance */}
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                <CurrencyDollarIcon className="w-5 h-5" />
                Account Balance
              </h4>

              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-700 dark:text-gray-300">Current Balance</p>
                  <p className="text-2xl font-bold text-green-600 dark:text-green-400">₹{typeof profileUser.balance === "number" ? profileUser.balance.toFixed(2) : Number(profileUser.balance || 0).toFixed(2)}</p>
                </div>
                {profileUser.expiry && (
                  <div>
                    <p className="text-sm font-medium text-gray-700 dark:text-gray-300">Expires On</p>
                    <p className="text-gray-900 dark:text-white">{new Date(profileUser.expiry).toLocaleDateString()}</p>
                  </div>
                )}
              </div>
            </div>

            {/* Social Media */}
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                <GlobeAltIcon className="w-5 h-5" />
                Social Media Links
              </h4>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {Object.entries(socialIcons).map(([platform, icon]) => (
                  <div key={platform}>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 flex items-center gap-2">
                      {icon}
                      {platform.charAt(0).toUpperCase() + platform.slice(1)}
                    </label>
                    {isEditing ? (
                      <input
                        type="url"
                        value={formData.socialMedia[platform]}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            socialMedia: { ...formData.socialMedia, [platform]: e.target.value },
                          })
                        }
                        className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                        placeholder={`https://${platform}.com/username`}
                      />
                    ) : (
                      <div className="flex items-center gap-2">
                        {profileUser.socialMedia?.[platform] ? (
                          <a
                            href={profileUser.socialMedia[platform]}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-green-600 dark:text-green-400 hover:underline"
                          >
                            {profileUser.socialMedia[platform]}
                          </a>
                        ) : (
                          <p className="text-gray-500 dark:text-gray-400">Not provided</p>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )

      case 2:
        return (
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">WhatsApp Credentials & API</h3>

            {/* API Key */}
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                <KeyIcon className="w-5 h-5" />
                API Key
              </h4>

              <div className="space-y-4">
                <div className="flex items-center gap-2">
                  <input
                    type={showApiKey ? "text" : "password"}
                    value={apiKey}
                    readOnly
                    className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white"
                  />
                  <button
                    onClick={() => setShowApiKey(!showApiKey)}
                    className="p-2 text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200"
                  >
                    {showApiKey ? <EyeSlashIcon className="w-5 h-5" /> : <EyeIcon className="w-5 h-5" />}
                  </button>
                  <button
                    onClick={() => copyToClipboard(apiKey)}
                    className="p-2 text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200"
                  >
                    <ClipboardDocumentIcon className="w-5 h-5" />
                  </button>
                  {canEditWhatsAppCredentials(userId) && (
                    <button
                      onClick={handleRegenerateApiKey}
                      className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors"
                    >
                      Regenerate
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* WhatsApp Business Settings */}
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">WhatsApp Business Settings</h4>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Primary Sender Label
                  </label>
                  {isEditing && canEditWhatsAppCredentials(userId) ? (
                    <input
                      type="text"
                      value={formData.label || ""}
                      onChange={(e) => setFormData({ ...formData, label: e.target.value })}
                      placeholder="e.g. Primary Support"
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.label || profileUser.username || "Not provided"}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    WhatsApp Token
                  </label>
                  {isEditing && canEditWhatsAppCredentials(userId) ? (
                    <input
                      type="text"
                      value={formData.wptoken}
                      onChange={(e) => setFormData({ ...formData, wptoken: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">
                      {profileUser.wptoken ? "••••••••••••" : "Not provided"}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Cloud Number
                  </label>
                  {isEditing && canEditWhatsAppCredentials(userId) ? (
                    <input
                      type="text"
                      value={formData.cloudNumber}
                      onChange={(e) => setFormData({ ...formData, cloudNumber: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.cloudNumber || "Not provided"}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Phone Number ID
                  </label>
                  {isEditing && canEditWhatsAppCredentials(userId) ? (
                    <input
                      type="text"
                      value={formData.phoneNumberId}
                      onChange={(e) => setFormData({ ...formData, phoneNumberId: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.phoneNumberId || "Not provided"}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">WABA ID</label>
                  {isEditing && canEditWhatsAppCredentials(userId) ? (
                    <input
                      type="text"
                      value={formData.wabaId}
                      onChange={(e) => setFormData({ ...formData, wabaId: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.wabaId || "Not provided"}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Business ID</label>
                  {isEditing && canEditWhatsAppCredentials(userId) ? (
                    <input
                      type="text"
                      value={formData.businessId}
                      onChange={(e) => setFormData({ ...formData, businessId: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.businessId || "Not provided"}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Business Account ID
                  </label>
                  {isEditing && canEditWhatsAppCredentials(userId) ? (
                    <input
                      type="text"
                      value={formData.businessAccountId}
                      onChange={(e) => setFormData({ ...formData, businessAccountId: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.businessAccountId || "Not provided"}</p>
                  )}
                </div>
              </div>
            </div>

            {/* Multiple WABA Numbers Section */}
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700 mt-6">
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Additional WABA Sender Numbers</h4>
              <p className="text-sm text-gray-500 mb-4">Add multiple numbers here to allow selecting a specific sender number during campaigns.</p>
              
              <div className="space-y-4">
                {(formData.wabaNumbers || []).map((waba, index) => (
                  <div key={index} className="grid grid-cols-1 md:grid-cols-5 gap-4 p-4 border rounded bg-gray-50 dark:bg-gray-900 border-gray-200 dark:border-gray-700 relative">
                    {isEditing && canEditWhatsAppCredentials(userId) && (
                      <button 
                        type="button" 
                        onClick={() => {
                          const newNumbers = [...(formData.wabaNumbers || [])]
                          newNumbers.splice(index, 1)
                          setFormData({ ...formData, wabaNumbers: newNumbers })
                        }}
                        className="absolute top-2 right-2 text-red-500 hover:text-red-700 font-bold"
                      >
                        ✕
                      </button>
                    )}
                    
                    <div>
                      <label className="block text-xs text-gray-500 mb-1">Phone Number ID</label>
                      {isEditing && canEditWhatsAppCredentials(userId) ? (
                        <input type="text" value={waba.phoneNumberId || ""} onChange={(e) => {
                          const newNumbers = [...formData.wabaNumbers]
                          newNumbers[index].phoneNumberId = e.target.value
                          setFormData({ ...formData, wabaNumbers: newNumbers })
                        }} className="w-full px-2 py-1 border rounded text-sm bg-white dark:bg-gray-700 text-black dark:text-white" />
                      ) : (
                        <p className="text-sm text-gray-900 dark:text-white">{waba.phoneNumberId}</p>
                      )}
                    </div>
                    
                    <div>
                      <label className="block text-xs text-gray-500 mb-1">Cloud Number</label>
                      {isEditing && canEditWhatsAppCredentials(userId) ? (
                        <input type="text" value={waba.cloudNumber || ""} onChange={(e) => {
                          const newNumbers = [...formData.wabaNumbers]
                          newNumbers[index].cloudNumber = e.target.value
                          setFormData({ ...formData, wabaNumbers: newNumbers })
                        }} className="w-full px-2 py-1 border rounded text-sm bg-white dark:bg-gray-700 text-black dark:text-white" placeholder="e.g. 919999999999" />
                      ) : (
                        <p className="text-sm text-gray-900 dark:text-white">{waba.cloudNumber}</p>
                      )}
                    </div>

                    <div>
                      <label className="block text-xs text-gray-500 mb-1">WABA ID (Optional)</label>
                      {isEditing && canEditWhatsAppCredentials(userId) ? (
                        <input type="text" value={waba.wabaId || ""} onChange={(e) => {
                          const newNumbers = [...formData.wabaNumbers]
                          newNumbers[index].wabaId = e.target.value
                          setFormData({ ...formData, wabaNumbers: newNumbers })
                        }} className="w-full px-2 py-1 border rounded text-sm bg-white dark:bg-gray-700 text-black dark:text-white" placeholder="e.g. 32235..." />
                      ) : (
                        <p className="text-sm text-gray-900 dark:text-white">{waba.wabaId || "N/A"}</p>
                      )}
                    </div>

                    <div>
                      <label className="block text-xs text-gray-500 mb-1">Custom Token (Optional)</label>
                      {isEditing && canEditWhatsAppCredentials(userId) ? (
                        <input type="text" value={waba.token || ""} onChange={(e) => {
                          const newNumbers = [...formData.wabaNumbers]
                          newNumbers[index].token = e.target.value
                          setFormData({ ...formData, wabaNumbers: newNumbers })
                        }} className="w-full px-2 py-1 border rounded text-sm bg-white dark:bg-gray-700 text-black dark:text-white" />
                      ) : (
                        <p className="text-sm text-gray-900 dark:text-white">{waba.token ? "••••••••" : "Uses Main Token"}</p>
                      )}
                    </div>
                    
                    <div>
                      <label className="block text-xs text-gray-500 mb-1">Label (Optional)</label>
                      {isEditing && canEditWhatsAppCredentials(userId) ? (
                        <input type="text" value={waba.label || ""} onChange={(e) => {
                          const newNumbers = [...formData.wabaNumbers]
                          newNumbers[index].label = e.target.value
                          setFormData({ ...formData, wabaNumbers: newNumbers })
                        }} className="w-full px-2 py-1 border rounded text-sm bg-white dark:bg-gray-700 text-black dark:text-white" placeholder="e.g. Sales Team" />
                      ) : (
                        <p className="text-sm text-gray-900 dark:text-white">{waba.label || "N/A"}</p>
                      )}
                    </div>
                  </div>
                ))}
                
                {isEditing && canEditWhatsAppCredentials(userId) && (
                  <button
                    type="button"
                    onClick={() => {
                      setFormData({
                        ...formData,
                        wabaNumbers: [...(formData.wabaNumbers || []), { phoneNumberId: "", cloudNumber: "", wabaId: "", token: "", label: "" }]
                      })
                    }}
                    className="mt-2 px-4 py-2 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-800 dark:text-white text-sm font-medium rounded-lg transition-colors border border-gray-300 dark:border-gray-600"
                  >
                    + Add Number
                  </button>
                )}
              </div>
            </div>
          </div>
        )

      case 3:
        return (
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Authentication & IP Details</h3>

            {/* Two Factor Authentication */}
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                <KeyIcon className="w-5 h-5" />
                Two-Factor Authentication
              </h4>

              <div className="flex items-center justify-between gap-4">
                <div>
                  <p className="text-sm font-medium text-gray-700 dark:text-gray-300">Authenticator app verification</p>
                  <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                    {profileUser.twoFactorEnabled
                      ? "A 6-digit authenticator code is required after password login."
                      : "Disabled by default. Enable it by scanning a QR code in Google Authenticator, Microsoft Authenticator, or Authy."}
                  </p>
                </div>
                <button
                  onClick={handleToggleTwoFactor}
                  disabled={!canEditProfile(userId) || loading}
                  className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 ${
                    profileUser.twoFactorEnabled ? "bg-green-600" : "bg-gray-200"
                  } ${!canEditProfile(userId) || loading ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                  <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                      profileUser.twoFactorEnabled ? "translate-x-6" : "translate-x-1"
                    }`}
                  />
                </button>
              </div>

              {twoFactorSetup && !profileUser.twoFactorEnabled && (
                <div className="mt-6 grid grid-cols-1 lg:grid-cols-[220px_1fr] gap-6 rounded-xl border border-green-200 dark:border-green-800 bg-green-50/60 dark:bg-green-900/20 p-4">
                  <div className="flex items-center justify-center">
                    <img
                      src={twoFactorSetup.qrCodeDataUrl}
                      alt="Authenticator setup QR code"
                      className="w-48 h-48 rounded-lg bg-white p-2 border border-gray-200"
                    />
                  </div>
                  <div className="space-y-4">
                    <div>
                      <p className="text-sm font-medium text-gray-700 dark:text-gray-300">Manual setup key</p>
                      <div className="mt-2 flex gap-2">
                        <input
                          value={twoFactorSetup.secret || ""}
                          readOnly
                          className="flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white font-mono text-sm"
                        />
                        <button
                          onClick={() => copyToClipboard(twoFactorSetup.secret)}
                          className="px-3 py-2 bg-gray-700 hover:bg-gray-800 text-white rounded-lg transition-colors"
                        >
                          Copy
                        </button>
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Authenticator code
                      </label>
                      <input
                        type="text"
                        value={twoFactorSetupCode}
                        onChange={(e) => setTwoFactorSetupCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
                        placeholder="000000"
                        maxLength="6"
                        className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white tracking-widest text-center text-lg focus:ring-2 focus:ring-green-500"
                      />
                    </div>

                    <div className="flex flex-wrap gap-2">
                      <button
                        onClick={handleConfirmTwoFactorSetup}
                        disabled={loading || twoFactorSetupCode.length !== 6}
                        className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        Verify and Enable
                      </button>
                      <button
                        onClick={() => {
                          setTwoFactorSetup(null)
                          setTwoFactorSetupCode("")
                        }}
                        className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-lg transition-colors"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* IP Whitelist */}
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                <ShieldCheckIcon className="w-5 h-5" />
                IP Whitelist Management
              </h4>

              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-700 dark:text-gray-300">IP Whitelist Enabled</span>
                  <button
                    onClick={handleToggleUserIPWhitelist}
                    disabled={!canEditProfile(userId) || loading}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 ${
                      profileUser.ipWhitelistEnabled ? "bg-green-600" : "bg-gray-200"
                    } ${!canEditProfile(userId) || loading ? "opacity-50 cursor-not-allowed" : ""}`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                        profileUser.ipWhitelistEnabled ? "translate-x-6" : "translate-x-1"
                      }`}
                    />
                  </button>
                </div>

                {canEditProfile(userId) && (
                  <div className="flex flex-col sm:flex-row gap-2">
                    <textarea
                      value={newIP}
                      onChange={(e) => setNewIP(e.target.value)}
                      placeholder="Enter one or multiple IPs, separated by comma or new line"
                      rows="2"
                      className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                    <button
                      onClick={handleAddIP}
                      className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors"
                    >
                      Add IPs
                    </button>
                  </div>
                )}

                <div className="space-y-2">
                  {profileUser.ipWhitelist && profileUser.ipWhitelist.length > 0 ? (
                    profileUser.ipWhitelist.map((ipEntry, index) => (
                      <div
                        key={index}
                        className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg"
                      >
                        <div className="flex items-center gap-3">
                          <span className="text-gray-900 dark:text-white font-mono">{ipEntry.ip}</span>
                          <span
                            className={`px-2 py-1 text-xs rounded-full ${
                              ipEntry.isActive
                                ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
                                : "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
                            }`}
                          >
                            {ipEntry.isActive ? "Active" : "Inactive"}
                          </span>
                        </div>
                        {canEditProfile(userId) && (
                          <div className="flex items-center gap-2">
                            <button
                              onClick={() => handleToggleIPWhitelistStatus(ipEntry.ip, !ipEntry.isActive)}
                              className="px-3 py-1 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded transition-colors"
                            >
                              {ipEntry.isActive ? "Disable" : "Enable"}
                            </button>
                            <button
                              onClick={() => handleRemoveIP(ipEntry.ip)}
                              className="px-3 py-1 text-sm bg-red-600 hover:bg-red-700 text-white rounded transition-colors"
                            >
                              Remove
                            </button>
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <p className="text-gray-500 dark:text-gray-400 text-center py-4">No IP addresses in whitelist</p>
                  )}
                </div>
              </div>
            </div>

            {/* IP Blocklist */}
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                <XCircleIcon className="w-5 h-5" />
                IP Blocklist Management
              </h4>

              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-700 dark:text-gray-300">IP Blocklist Enabled</span>
                  <button
                    onClick={handleToggleUserIPBlocklist}
                    disabled={!canEditProfile(userId) || loading}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 ${
                      profileUser.ipBlocklistEnabled ? "bg-red-600" : "bg-gray-200"
                    } ${!canEditProfile(userId) || loading ? "opacity-50 cursor-not-allowed" : ""}`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                        profileUser.ipBlocklistEnabled ? "translate-x-6" : "translate-x-1"
                      }`}
                    />
                  </button>
                </div>

                {canEditProfile(userId) && (
                  <div className="flex flex-col sm:flex-row gap-2">
                    <textarea
                      value={newBlockedIP}
                      onChange={(e) => setNewBlockedIP(e.target.value)}
                      placeholder="Enter one or multiple IPs to block, separated by comma or new line"
                      rows="2"
                      className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-red-500"
                    />
                    <button
                      onClick={handleAddBlockedIP}
                      className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors"
                    >
                      Block IPs
                    </button>
                  </div>
                )}

                <div className="space-y-2">
                  {profileUser.ipBlocklist && profileUser.ipBlocklist.length > 0 ? (
                    profileUser.ipBlocklist.map((ipEntry, index) => (
                      <div
                        key={index}
                        className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg"
                      >
                        <div className="flex items-center gap-3">
                          <span className="text-gray-900 dark:text-white font-mono">{ipEntry.ip}</span>
                          <span
                            className={`px-2 py-1 text-xs rounded-full ${
                              ipEntry.isActive
                                ? "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
                                : "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200"
                            }`}
                          >
                            {ipEntry.isActive ? "Blocked" : "Inactive"}
                          </span>
                        </div>
                        {canEditProfile(userId) && (
                          <div className="flex items-center gap-2">
                            <button
                              onClick={() => handleToggleIPBlocklistStatus(ipEntry.ip, !ipEntry.isActive)}
                              className="px-3 py-1 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded transition-colors"
                            >
                              {ipEntry.isActive ? "Disable" : "Enable"}
                            </button>
                            <button
                              onClick={() => handleRemoveBlockedIP(ipEntry.ip)}
                              className="px-3 py-1 text-sm bg-red-600 hover:bg-red-700 text-white rounded transition-colors"
                            >
                              Remove
                            </button>
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <p className="text-gray-500 dark:text-gray-400 text-center py-4">No IP addresses in blocklist</p>
                  )}
                </div>
              </div>
            </div>

            {/* Login Information */}
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Login Information</h4>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <p className="text-sm font-medium text-gray-700 dark:text-gray-300">Registration IP</p>
                  <p className="text-gray-900 dark:text-white font-mono">
                    {profileUser.registrationIP || "Not available"}
                  </p>
                </div>

                <div>
                  <p className="text-sm font-medium text-gray-700 dark:text-gray-300">Last Login IP</p>
                  <p className="text-gray-900 dark:text-white font-mono">
                    {profileUser.lastLoginIP || "Not available"}
                  </p>
                </div>

                <div>
                  <p className="text-sm font-medium text-gray-700 dark:text-gray-300">Account Created</p>
                  <p className="text-gray-900 dark:text-white">{new Date(profileUser.createdAt).toLocaleString()}</p>
                </div>

                <div>
                  <p className="text-sm font-medium text-gray-700 dark:text-gray-300">Last Updated</p>
                  <p className="text-gray-900 dark:text-white">{new Date(profileUser.updatedAt).toLocaleString()}</p>
                </div>
              </div>
            </div>
          </div>
        )

      case 4:
        return (
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Other Details</h3>

            {/* Personal Details */}
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                <MapPinIcon className="w-5 h-5" />
                Personal Details
              </h4>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Date of Birth
                  </label>
                  {isEditing ? (
                    <input
                      type="date"
                      value={formData.dateOfBirth}
                      onChange={(e) => setFormData({ ...formData, dateOfBirth: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">
                      {profileUser.dateOfBirth
                        ? new Date(profileUser.dateOfBirth).toLocaleDateString()
                        : "Not provided"}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Gender</label>
                  {isEditing ? (
                    <select
                      value={formData.gender}
                      onChange={(e) => setFormData({ ...formData, gender: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.gender || "Not provided"}</p>
                  )}
                </div>

                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Address</label>
                  {isEditing ? (
                    <textarea
                      value={formData.address}
                      onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                      rows="3"
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.address || "Not provided"}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">City</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={formData.city}
                      onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.city || "Not provided"}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">State</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={formData.state}
                      onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.state || "Not provided"}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Country</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={formData.country}
                      onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.country || "Not provided"}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Zip Code</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={formData.zipCode}
                      onChange={(e) => setFormData({ ...formData, zipCode: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.zipCode || "Not provided"}</p>
                  )}
                </div>
              </div>
            </div>

            {/* Professional Details */}
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                <BriefcaseIcon className="w-5 h-5" />
                Professional Details
              </h4>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Job Title</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={formData.jobTitle}
                      onChange={(e) => setFormData({ ...formData, jobTitle: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.jobTitle || "Not provided"}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Company</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={formData.company}
                      onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.company || "Not provided"}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Department</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={formData.department}
                      onChange={(e) => setFormData({ ...formData, department: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.department || "Not provided"}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Website</label>
                  {isEditing ? (
                    <input
                      type="url"
                      value={formData.website}
                      onChange={(e) => setFormData({ ...formData, website: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                    />
                  ) : (
                    <div>
                      {profileUser.website ? (
                        <a
                          href={profileUser.website}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-green-600 dark:text-green-400 hover:underline"
                        >
                          {profileUser.website}
                        </a>
                      ) : (
                        <p className="text-gray-500 dark:text-gray-400">Not provided</p>
                      )}
                    </div>
                  )}
                </div>

                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Bio</label>
                  {isEditing ? (
                    <textarea
                      value={formData.bio}
                      onChange={(e) => setFormData({ ...formData, bio: e.target.value })}
                      rows="4"
                      maxLength="500"
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                      placeholder="Tell us about yourself (max 500 characters)"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">{profileUser.bio || "Not provided"}</p>
                  )}
                </div>
              </div>
            </div>

            {/* Account Settings */}
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Account Settings</h4>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <p className="text-sm font-medium text-gray-700 dark:text-gray-300">Role</p>
                  <span
                    className={`inline-block px-3 py-1 rounded-full text-sm font-semibold ${
                      profileUser.role === "superadmin"
                        ? "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200"
                        : profileUser.role === "admin"
                          ? "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
                          : profileUser.role === "reseller"
                            ? "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200"
                            : profileUser.role === "company"
                              ? "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200"
                              : "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200"
                    }`}
                  >
                    {profileUser.role.charAt(0).toUpperCase() + profileUser.role.slice(1)}
                  </span>
                </div>
                
                <div>
                  <p className="text-sm font-medium text-gray-700 dark:text-gray-300">Status</p>
                  <span
                    className={`inline-block px-3 py-1 rounded-full text-sm font-semibold ${
                      profileUser.userStatus === "active"
                        ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
                        : "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
                    }`}
                  >
                    {profileUser.userStatus.charAt(0).toUpperCase() + profileUser.userStatus.slice(1)}
                  </span>
                </div>

                <div>
                  <div className="space-y-2">
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-medium text-gray-700 dark:text-gray-300">Email Notifications</span>
                      <span
                        className={`px-2 py-1 text-xs rounded-full ${
                          profileUser.emailNotifications
                            ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
                            : "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
                        }`}
                      >
                        {profileUser.emailNotifications ? "Enabled" : "Disabled"}
                      </span>
                    </div>

                    <div className="flex items-center justify-between">
                      <span className="text-sm font-medium text-gray-700 dark:text-gray-300">SMS Notifications</span>
                      <span
                        className={`px-2 py-1 text-xs rounded-full ${
                          profileUser.smsNotifications
                            ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
                            : "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
                        }`}
                      >
                        {profileUser.smsNotifications ? "Enabled" : "Disabled"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Message Settings */}
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700 mt-6">
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Message Keywords</h4>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Opt-Out Keywords (Comma separated)</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={formData.settings?.optOutKeywords?.join(", ") || ""}
                      onChange={(e) => setFormData({ 
                        ...formData, 
                        settings: { ...formData.settings, optOutKeywords: e.target.value.split(",").map(k => k.trim()).filter(k => k) }
                      })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                      placeholder="stop, unsubscribe, cancel"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">
                      {profileUser.settings?.optOutKeywords?.join(", ") || "None"}
                    </p>
                  )}
                  <p className="text-xs text-gray-500 mt-1">Users replying with these will be unsubscribed.</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Opt-In Keywords (Comma separated)</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={formData.settings?.optInKeywords?.join(", ") || ""}
                      onChange={(e) => setFormData({ 
                        ...formData, 
                        settings: { ...formData.settings, optInKeywords: e.target.value.split(",").map(k => k.trim()).filter(k => k) }
                      })}
                      className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500"
                      placeholder="start, subscribe"
                    />
                  ) : (
                    <p className="text-gray-900 dark:text-white">
                      {profileUser.settings?.optInKeywords?.join(", ") || "None"}
                    </p>
                  )}
                  <p className="text-xs text-gray-500 mt-1">Users replying with these will be resubscribed.</p>
                </div>
              </div>
            </div>

          </div>
        )

      default:
        return null
    }
  }

  if (!userId) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-yellow-50 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Invalid URL</h1>
          <p className="text-gray-600 dark:text-gray-400">Please provide a valid user ID in the URL.</p>
          <p className="text-sm text-gray-500 dark:text-gray-500 mt-2">Expected format: /userprofile/[userId]</p>
        </div>
      </div>
    )
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-yellow-50 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading user profile...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-yellow-50 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">User Not Found</h1>
          <p className="text-gray-600 dark:text-gray-400">The requested user profile could not be found.</p>
        </div>
      </div>
    )
  }

  if (!canViewProfile(userId)) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-yellow-50 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Access Denied</h1>
          <p className="text-gray-600 dark:text-gray-400">You don't have permission to view this profile.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-yellow-50 dark:from-gray-900 dark:to-gray-800">
      <div className="px-2 sm:px-3 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
            <div>
              <h1 className="text-3xl lg:text-4xl font-bold bg-gradient-to-r from-green-700 to-yellow-600 bg-clip-text text-transparent mb-2">
                User Profile
              </h1>
              <p className="text-gray-600 dark:text-gray-400 text-lg">
                {profileUser.firstName && profileUser.lastName
                  ? `${profileUser.firstName} ${profileUser.lastName}`
                  : profileUser.username || profileUser.email}
              </p>
            </div>

            {canEditProfile(userId) && (
              <div className="mt-4 lg:mt-0 flex gap-3">
                {isEditing ? (
                  <>
                    <button
                      onClick={() => {
                        setIsEditing(false)
                        fetchUserProfile() // Reset form data
                      }}
                      className="px-6 py-3 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl transition-all duration-200 flex items-center gap-2"
                    >
                      <XMarkIcon className="w-5 h-5" />
                      Cancel
                    </button>
                    <button
                      onClick={handleSaveProfile}
                      disabled={loading}
                      className="bg-gradient-to-r from-green-500 to-yellow-500 hover:from-green-600 hover:to-yellow-500 text-white px-6 py-3 rounded-xl flex items-center gap-3 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 font-semibold disabled:opacity-50"
                    >
                      {loading ? (
                        <>
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                          Saving...
                        </>
                      ) : (
                        <>
                          <CheckIcon className="w-5 h-5" />
                          Save Changes
                        </>
                      )}
                    </button>
                  </>
                ) : (
                  <button
                    onClick={() => setIsEditing(true)}
                    className="bg-gradient-to-r from-green-500 to-yellow-500 hover:from-green-600 hover:to-yellow-500 text-white px-6 py-3 rounded-xl flex items-center gap-3 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 font-semibold"
                  >
                    <PencilIcon className="w-5 h-5" />
                    Edit Profile
                  </button>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Step Navigation */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {[1, 2, 3, 4].map((step) => (
                <button
                  key={step}
                  onClick={() => setCurrentStep(step)}
                  className={`flex items-center justify-center w-10 h-10 rounded-full text-sm font-medium transition-all duration-200 ${
                    step === currentStep
                      ? "bg-green-600 text-white shadow-lg"
                      : step < currentStep
                        ? "bg-green-200 text-green-800 dark:bg-green-800 dark:text-green-200"
                        : "bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-400"
                  }`}
                >
                  {step}
                </button>
              ))}
            </div>

            <div className="flex items-center gap-2">
              <button
                onClick={prevStep}
                disabled={currentStep === 1}
                className="p-2 text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-all duration-200"
              >
                <ArrowLeftIcon className="w-5 h-5" />
              </button>

              <span className="text-sm text-gray-500 dark:text-gray-400">Step {currentStep} of 4</span>

              <button
                onClick={nextStep}
                disabled={currentStep === 4}
                className="p-2 text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-all duration-200"
              >
                <ArrowRightIcon className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>

        {/* Step Content */}
        {renderStepContent()}

        {/* Email Verification Modal */}
        {showVerificationModal && (
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
            <div className="bg-white dark:bg-gray-800 rounded-2xl max-w-md w-full shadow-2xl">
              <div className="p-6 border-b border-gray-200 dark:border-gray-700">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white">Email Verification</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                  Enter the verification code sent to {profileUser.email}
                </p>
              </div>

              <div className="p-6">
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Verification Code
                    </label>
                    <input
                      type="text"
                      value={verificationCode}
                      onChange={(e) => setVerificationCode(e.target.value)}
                      className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
                      placeholder="Enter 6-digit code"
                      maxLength="6"
                    />
                  </div>
                </div>
              </div>

              <div className="p-6 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50">
                <div className="flex justify-end gap-3">
                  <button
                    onClick={() => {
                      setShowVerificationModal(false)
                      setVerificationCode("")
                    }}
                    className="px-6 py-2 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-600 rounded-lg transition-all duration-200"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleVerifyEmail}
                    disabled={loading || !verificationCode}
                    className="bg-green-700 hover:bg-green-800 disabled:bg-gray-400 text-white px-6 py-2 rounded-lg transition-all duration-200 flex items-center gap-2 font-semibold"
                  >
                    {loading ? (
                      <>
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                        Verifying...
                      </>
                    ) : (
                      <>
                        <CheckIcon className="w-4 h-4" />
                        Verify Email
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default UserProfile
